import { s } from '../lib/sx'
import { PageHero } from '../components/PageHero'
import { copy } from '../content/copy'
import { sectors } from '../content/sectors'

export function Sectors() {
  return (
    <div>
      <PageHero eyebrow="Sectors" title={copy.sectors.headline} />
      <section style={s('max-width:1320px;margin:0 auto;padding:0 clamp(18px,4vw,32px) 100px;')}>
        {sectors.map((sec, i) => (
          <div key={i} style={s('display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,260px),1fr));gap:clamp(24px,3vw,48px);padding:48px 0;border-bottom:1px solid #DCE0E5;align-items:start;')}>
            <h2 style={s('font-family:Archivo,sans-serif;font-weight:700;font-size:clamp(22px,2.8vw,30px);letter-spacing:-0.02em;margin:0;')}>{sec.name}</h2>
            <div>
              <p style={s('font-size:16px;line-height:1.65;color:#38424E;margin:0 0 14px;')}>{sec.blurb}</p>
              <div style={s("font-family:'IBM Plex Mono',monospace;font-size:12px;color:#7E8894;")}>{sec.clients}</div>
            </div>
            <div style={s('text-align:right;')}>
              <div style={s('font-family:Archivo,sans-serif;font-weight:700;font-size:24px;color:#A8500F;letter-spacing:-0.02em;')}>{sec.stat}</div>
            </div>
          </div>
        ))}
      </section>
    </div>
  )
}
